import { TypedDocumentNode, gql } from "@apollo/client";

export const GET_ACCREDITATIONS: TypedDocumentNode<{
  accreditations: {
    name: string;
    logo: string;
    logo_url: string;
    description: string;
    accreditation_link?: string;
  }[];
}> = gql`
  query GetAccreditations {
    accreditations {
      name
      logo
      logo_url
      description
      accreditation_link
    }
  }
`;
